(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller-laptop-deal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('laptop-deal-section')) {
    customElements.define('laptop-deal-section', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const tabs = Array.from(this.querySelectorAll('[data-deal-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-deal-panel]'));
        const mobile = window.matchMedia('(max-width: 989px)');
        let activePanel = panels[0]?.dataset.dealPanel;
        const updatePanels = () => {
          tabs.forEach((tab) => {
            const active = tab.dataset.dealTab === activePanel;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = mobile.matches && panel.dataset.dealPanel !== activePanel;
            if (mobile.matches && tabs.length) {
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('aria-labelledby', `DealTab-${this.id.replace('LaptopDeal-', '')}-${panel.dataset.dealPanel}`);
            } else {
              panel.removeAttribute('role');
              panel.setAttribute('aria-labelledby', panel.querySelector('h3').id);
            }
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            activePanel = tab.dataset.dealTab;
            updatePanels();
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = index;
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            const target = tabs[(next + tabs.length) % tabs.length];
            activePanel = target.dataset.dealTab;
            updatePanels();
            target.focus();
          }, { signal });
        });
        mobile.addEventListener('change', () => {
          const focusedPanel = panels.find((panel) => panel.contains(document.activeElement));
          if (focusedPanel) activePanel = focusedPanel.dataset.dealPanel;
          updatePanels();
        }, { signal });
        updatePanels();

        const main = this.querySelector('.lk-deal__image');
        const frame = this.querySelector('[data-deal-frame]');
        const gallery = this.querySelector('[data-deal-gallery]');
        const thumbnails = Array.from(this.querySelectorAll('[data-deal-thumb]'));
        const counter = this.querySelector('[data-deal-count]');
        let imageIndex = 0;
        const selectImage = (index) => {
          if (!main || !thumbnails.length) return;
          imageIndex = (index + thumbnails.length) % thumbnails.length;
          const thumb = thumbnails[imageIndex];
          main.srcset = thumb.dataset.srcset;
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt;
          main.width = Number(thumb.dataset.width);
          main.height = Number(thumb.dataset.height);
          thumbnails.forEach((item, position) => {
            item.classList.toggle('is-active', position === imageIndex);
            item.setAttribute('aria-pressed', String(position === imageIndex));
          });
          if (counter) counter.textContent = `${imageIndex + 1} / ${thumbnails.length}`;
          if (gallery && gallery.clientWidth) {
            const itemBox = thumb.getBoundingClientRect();
            const galleryBox = gallery.getBoundingClientRect();
            if (itemBox.left < galleryBox.left) gallery.scrollLeft += itemBox.left - galleryBox.left;
            else if (itemBox.right > galleryBox.right) gallery.scrollLeft += itemBox.right - galleryBox.right;
          }
        };
        thumbnails.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index), { signal }));
        this.querySelector('[data-deal-prev]')?.addEventListener('click', () => selectImage(imageIndex - 1), { signal });
        this.querySelector('[data-deal-next]')?.addEventListener('click', () => selectImage(imageIndex + 1), { signal });
        let touchStart = null;
        frame?.addEventListener('touchstart', (event) => {
          touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true, signal });
        frame?.addEventListener('touchmove', (event) => {
          if (event.touches.length !== 1) touchStart = null;
        }, { passive: true, signal });
        frame?.addEventListener('touchcancel', () => { touchStart = null; }, { signal });
        frame?.addEventListener('touchend', (event) => {
          if (!touchStart) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.3) selectImage(imageIndex + (dx < 0 ? 1 : -1));
        }, { passive: true, signal });
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
